import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppContainer from "../Components/Structure/AppContainer";

function ErrorPage() {
  const navigate = useNavigate();
  const [count, setCount] = useState(3); // 3-second countdown

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => prev - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate("/Dashboard");
      }
    }, 3000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [navigate]);

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/Dashboard");
    }
  };

  return (
    <AppContainer title="Dashboard/Error-page">
      <div
        style={{
          color: "white",
          fontFamily: "cursive",
          fontSize: "20px",
        }}
      >
        <div className="page main-signin-wrapper">
          <div className="row signpages text-center">
            <div
              style={{
                background: "rgba(255, 255, 255, 0.01)",
                backdropFilter: "blur(9px)",
                borderRadius: "20px",
                padding: "20px",
              }}
              className="col-md-8 mx-auto"
            >
              <div className="card alert-message">
                <div className="card-body">
                  <div className="text-center text-white">
                    <img
                      style={{ width: "300px", height: "200px" }}
                      src={process.env.PUBLIC_URL + "/errorImage.png"}
                      className="header-brand-img mb-4"
                      alt="logo"
                    />
                    <p className="tx-18 text-danger text-50">
                      Sorry !! Page Not Available.
                    </p>
                    <button
                      onClick={handleBack}
                      className="btn btn-warning"
                      style={{ borderRadius: "10px" }}
                    >
                      Back
                    </button>
                    <p className="mt-4 text-sm text-warning">
                      Redirecting in
                      <strong>
                        {count} second{count > 1 ? "s" : ""}
                      </strong>
                      ...
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
}

export default ErrorPage;
